import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';


const authRoutes: Routes = [
  /* { path: 'active-link', component: ActiveLinkComponent },*/
];

@NgModule({
    imports: [RouterModule.forChild(authRoutes)],
    exports: [RouterModule],
    providers: []
})
export class AuthRoutingModule {}


// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/auth/auth.routing.ts